import React from 'react';
import {
  Typography, Button, Dialog, DialogTitle,
  DialogContent, DialogActions, CircularProgress
} from '@mui/material';

const DeleteTenantDialog = ({ open, onClose, onConfirm, tenant, loading }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Delete Tenant</DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to permanently delete tenant <strong>{tenant?.id}</strong>
        {tenant?.data?.school_name && ` (${tenant.data.school_name})`}? This will drop its database and cannot be undone.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>Cancel</Button>
      <Button onClick={onConfirm} color="error" variant="contained" disabled={loading}>
        {loading ? <CircularProgress size={20} /> : 'Delete'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteTenantDialog;
